import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './CustomReaseonTooltip.module.scss';

const CustomReaseonTooltip = ({ dataTooltip, color }) => {
  return (
    <div className={classes.bodyTooltip}>
      <div className={classes.wrapColorName}>
        <div style={{ backgroundColor: color }} className={classes.colorBox} />
        <Text className={cn(classes.info, classes.info_name)}>
          {dataTooltip.name}
        </Text>
      </div>
      <Text className={cn(classes.info, classes.info_percent)}>
        {`${dataTooltip.percent}% (${dataTooltip.count})`}
      </Text>
    </div>
  );
};

CustomReaseonTooltip.propTypes = {
  dataTooltip: PropTypes.object,
  color: PropTypes.string
};

export default CustomReaseonTooltip;
